import React from 'react';
import { ArrowRight } from 'lucide-react';
const services = [{
  label: 'Ducted Reverse Cycle Installation',
  href: '/ducted-air-conditioning/'
}, {
  label: 'Split System Installation',
  href: '/split-systems-perth/'
}, {
  label: 'Reverse Cycle Air Conditioning',
  href: '/reverse-cycle-air-conditioning-perth/'
}, {
  label: 'Multi Head Splits',
  href: '/split-systems-perth/'
}, {
  label: 'Commercial Air Conditioning',
  href: '/commercial-air-conditioning-installation-in-perth/'
}, {
  label: 'Aircon Removal',
  href: '/air-conditioner-removals/'
}, {
  label: 'Smart Zone Control',
  href: '/smart-zone/'
}];
const brands = [{
  label: 'Mitsubishi Electric',
  href: '/brand/mitsubishi-air-conditioner-perth/'
}, {
  label: 'Daikin',
  href: '/brand/daikin-air-conditioning-perth/'
}, {
  label: 'Rinnai HRV',
  href: '/brand/rinnai-air-conditioning-perth/'
}, {
  label: 'Fujitsu',
  href: '/brand/'
}];
const suburbs = [{
  label: 'Air Conditioning Joondalup',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Wanneroo',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Stirling',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Karrinyup',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Subiaco',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Mount Lawley',
  href: '#suburbs'
}, {
  label: 'View all Perth suburbs',
  href: '#suburbs'
}];
export function TopicalAuthority() {
  return <section className="bg-paper py-20 md:py-24" data-id="element-749" data-mp="283xs9m8dnbfg">
      <div className="max-w-6xl mx-auto px-6" data-id="element-750" data-mp="283ecab2aex42">
        <div className="kicker mb-3" data-id="element-751" data-mp="242ucezqbxfe8">Explore Langler Air</div>
        <h2 className="text-2xl md:text-3xl font-bold text-ink-900 tracking-tight mb-10" data-id="element-752" data-mp="244p1mq8mvto4">
          Services, brands and Perth suburbs we cover.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-753" data-mp="2d4btolfh3n4i">
          <div data-id="element-754" data-mp="1apuntjmq928z">
            <h3 className="text-xs font-bold uppercase tracking-widest text-brand mb-4" data-id="element-755" data-mp="1aqe7p5vxu0pn">
              Services
            </h3>
            <ul className="space-y-2.5" data-id="element-756" data-mp="1es9aketiom5j">
              {services.map(s => <li key={s.label} data-id="element-757" data-mp="1jqauf1yropi2">
                  <a href={s.href} className="text-sm text-ink-900 hover:text-brand inline-flex items-center gap-1.5 group" data-id="element-758" data-mp="1jp82qrtmej13">
                    <ArrowRight size={11} className="text-stone-400 group-hover:text-brand group-hover:translate-x-0.5 transition-all" data-id="element-759" data-mp="1tfuajzv3i598" />
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-760" data-mp="27e10mttsz0yc">
            <h3 className="text-xs font-bold uppercase tracking-widest text-brand mb-4" data-id="element-761" data-mp="830zh34fr0oz">
              Brands we install
            </h3>
            <ul className="space-y-2.5" data-id="element-762" data-mp="d35hixkzs3hb">
              {brands.map(b => <li key={b.label} data-id="element-763" data-mp="5j39kqnokll7">
                  <a href={b.href} className="text-sm text-ink-900 hover:text-brand inline-flex items-center gap-1.5 group" data-id="element-764" data-mp="5jd0qhkgoysh">
                    <ArrowRight size={11} className="text-stone-400 group-hover:text-brand group-hover:translate-x-0.5 transition-all" data-id="element-765" data-mp="3rz7iwe2vtlq2" />
                    {b.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-766" data-mp="jivuu6gfu9ls">
            <h3 className="text-xs font-bold uppercase tracking-widest text-brand mb-4" data-id="element-767" data-mp="jg9oub97425o">
              Perth area guides
            </h3>
            <ul className="space-y-2.5" data-id="element-768" data-mp="ai7hzf2s6fah">
              {suburbs.map(s => <li key={s.label} data-id="element-769" data-mp="2z9if5sysf7kr">
                  <a href={s.href} className="text-sm text-ink-900 hover:text-brand inline-flex items-center gap-1.5 group" data-id="element-770" data-mp="2z9qqvhj6c6ud">
                    <ArrowRight size={11} className="text-stone-400 group-hover:text-brand group-hover:translate-x-0.5 transition-all" data-id="element-771" data-mp="myp0nbhqtrib" />
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}